import logger from './utils/logger.js';

// Function: Pushes "sign_up" event to dataLayer
// Specs:
// - This function should be called whenever a user registers for an account
const dataLayerRegister = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: 'sign_up',
        ecommerce: {
            method: 'site registration',
        },
    });
    logger('sign_up event sent', { category: 'analytics' });
};

export { dataLayerRegister as d };
//# sourceMappingURL=register-J9OaMUYD.js.map
